//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    mobileButtonText: {
      type: String,
      required: true,
    },
    desktopButtonText: {
      type: String,
      required: true,
    },
    buttonTextColor: {
      type: String,
      default: '',
    },
    buttonBgColor: {
      type: String,
      default: '',
    },
  },
};
